import { Box, SelectChangeEvent, Typography } from '@mui/material'
import React from 'react'
import { InvestorLineChatProps } from '../type'
import FilterDropDown from './FilterDropDown'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getChartA11yOptions } from '../../../utils/highchartsAccessibility';


const InvestorLineChat = (props: InvestorLineChatProps) => {

    const { options, isLoading, defaultValue, filterHandleChange, chartOption } = props

    const a11y = getChartA11yOptions({
        altText: 'Number of Investors line chart',
        description: 'Line chart showing the total number of investors over time for the selected filter.',
    });
    const accessibleChartOption = {
        ...(chartOption || {}),
        title: a11y.title,
        accessibility: a11y.accessibility,
        chart: {
            ...((chartOption && (chartOption as any).chart) || {}),
            description: a11y.chartDescription,
        },
    };

    return (
        <Box padding={'30px'} >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='h2'>Number of Investors</Typography>
                <FilterDropDown options={options} isLoading={isLoading} defaultValue={defaultValue} handleChange={filterHandleChange} />
            </Box>
            <Box paddingTop={'35px'}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={accessibleChartOption}
                />
            </Box>
        </Box>
    )
}

export default InvestorLineChat

